export default {"src":"/_next/static/media/facebookIcon.8a7f5b02.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};